<div class="">
  @if (subtitle) {
    <div class="uk-text-secondary uk-text-bold uk-text-italic uk-margin-bottom">{{subtitle}}</div>
  }
  <div class="uk-flex uk-flex-between uk-margin-small-bottom">
    <span>National OA policy</span>
    @if (nationalPolicy === null) {
      <span class="material-icons uk-text-bold">N/A</span>
    }
    @if (nationalPolicy === 'Yes') {
      <span class="material-icons uk-text-bold" style="color: #2D9D78">check</span>
    }
    @if (nationalPolicy === 'No') {
      <span class="material-icons uk-text-bold" style="color: #D12D17">close</span>
    }
  </div>
  <div class="uk-flex uk-flex-between uk-margin-small-bottom">
    <span>Financial strategy on OA</span>
    @if (financialStrategy === null) {
      <span class="material-icons uk-text-bold">N/A</span>
    }
    @if (financialStrategy === 'Yes') {
      <span class="material-icons uk-text-bold" style="color: #2D9D78">check</span>
    }
    @if (financialStrategy === 'No') {
      <span class="material-icons uk-text-bold" style="color: #D12D17">close</span>
    }
  </div>
  <div class="uk-flex uk-flex-middle uk-margin-small-bottom">
    <span class="uk-text-bold uk-margin-right uk-text-lead">{{rpos ? rpos : 'N/A'}}</span>
    <span class="">RPOs with OA policy</span>
  </div>
  <div class="uk-flex uk-flex-middle uk-margin-small-bottom">
    <span class="uk-text-bold uk-margin-right uk-text-lead">{{rfos ? rfos : 'N/A'}}</span>
    <span class="">RFOs with OA policy</span>
  </div>
</div>
